import z from "zod";

const translationPath = "page.4uBus.relationships.relationshipGroup.errors.";

const uBusAutomationSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "u_bus_automation" },
);

export const relationshipGroupSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  name: z.string().min(1, translationPath + "name"),
  description: z.string().nullish(),
  uBusAutomation: uBusAutomationSchema,
});

export type TRelationshipGroupForm = z.infer<typeof relationshipGroupSchema>;
